// extracted by mini-css-extract-plugin
module.exports = {"root":"TopBar_root__2Bb6b","toolbar":"TopBar_toolbar__2ZbOO","logo":"TopBar_logo__3Q4Cf"};